import { ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { lightTheme } from '../styles/theme';
import Header from './Header';

const Layout = () => {
  useEffect(() => {
    document.body.className = 'light-theme';
  }, []);

  return (
    <ThemeProvider theme={lightTheme}>
      <Header />
      <Outlet />
    </ThemeProvider>
  );
};

export default Layout;
